export enum WelcomeMessageSource {
  BILLING = 'BILLING',
}

export interface AiCommunicationsState {
  triggeredBySetLive: boolean
  triggeredByPurchase: boolean
  isWelcomeMessageVisible: boolean
  showAfterUpgrade: boolean
  welcomeMessageSource: WelcomeMessageSource
}
